import { actionTypes as slotTypes } from 'modules/Slot';

export default {
  keyMapping: {
    type: 'gcmevent'
  },
  entities: {
    gameAnimationStart: { type: slotTypes.T.ROUND_STARTED },
    gameAnimationComplete: { type: slotTypes.T.ROUND_ENDED }
  }
};
